export default class StarsRenderer {
  fullStar = document.getElementById('js-star-full-sample').children[0];
  halfStar = document.getElementById('js-star-half-sample').children[0];
  emptyStar = document.getElementById('js-star-empty-sample').children[0];
  maxRating = 5;
  halfStarThreshold = 0.1;

  render = (container, averageRating) => {
    if (container) {
      this.clearStarsWrapper(container);
      this.drawFullStars(container, averageRating);
      this.drawHalfStars(container, averageRating);
      this.drawEmptyStars(container, averageRating);
      this.removeZeroState(container, averageRating);
    }
  };

  fullStarsCount = (averageRating) => Math.trunc(averageRating);
  halfStarsCount =
    (averageRating) => (averageRating - this.fullStarsCount(averageRating) >= this.halfStarThreshold ? 1 : 0);

  emptyStarsCount =
    (averageRating) => this.maxRating - this.fullStarsCount(averageRating) - this.halfStarsCount(averageRating);

  removeZeroState = (wrapper, averageRating) => {
    if (averageRating > 0) {
      wrapper.classList.remove('product-rating__stars--zero-state');
    }
  };

  clearStarsWrapper = (wrapper) => wrapper.innerHTML = '';

  drawFullStars = (wrapper, averageRating) => {
    this.drawStars(wrapper, this.fullStar, this.fullStarsCount(averageRating));
  };

  drawHalfStars = (wrapper, averageRating) => {
    this.drawStars(wrapper, this.halfStar, this.halfStarsCount(averageRating));
  };

  drawEmptyStars = (wrapper, averageRating) => {
    this.drawStars(wrapper, this.emptyStar, this.emptyStarsCount(averageRating));
  };

  drawStars = (wrapper, starNode, count) => {
    for (let index = 0; index < count; index++) {
      wrapper.appendChild(starNode.cloneNode(true));
    }
  };
}
